import { useState } from 'react';
import { Share2, Check, Copy } from 'lucide-react';
import { C } from '../constants';

export default function ShareButton({ stateId, stateName, accent }) {
  const [state, setState] = useState('idle'); // idle | copied

  const handleShare = async () => {
    const url  = `${window.location.origin}/${stateId}`;
    const text = `Who would you vote for in ${stateName} — without any freebies? Cast your unofficial vote here:`;

    if (navigator.share) {
      try {
        await navigator.share({ title: 'Unofficial Election', text, url });
      } catch (_) {}
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setState('copied');
      setTimeout(() => setState('idle'), 2500);
    } catch (_) {}
  };

  const color  = accent || C.cyan;
  const copied = state === 'copied';

  return (
    <button
      onClick={handleShare}
      className="inline-flex items-center gap-2"
      style={{
        background:           copied ? `${color}18` : C.cardBg,
        border:               `1px solid ${copied ? color + '66' : C.border}`,
        padding:              '8px 16px',
        borderRadius:         999,
        fontSize:             '0.82rem',
        fontWeight:           600,
        color:                copied ? color : C.white,
        cursor:               'pointer',
        backdropFilter:       'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        transition:           'all 200ms ease',
        fontFamily:           "'Poppins', sans-serif",
        flexShrink:           0,
      }}
    >
      {copied
        ? <Check size={14} strokeWidth={2.5} />
        : <Share2 size={14} />}
      {copied ? 'Link copied!' : 'Invite to Vote'}
    </button>
  );
}
